<script setup lang="ts">
import '@/assets/scss/helpers/_hero.scss';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import ToastNotification from '@/components/devextreme/ToastNotification.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import AppHeader from '@/components/layout/AppHeader.vue';
// Here instead of main.ts, so the login pages don't load DataGrid and the other widgets set up there.
import '@/constants/DxDefaults';
import Routes from '@/constants/Routes';

definePage({ name: 'HomeRoot', meta: { title: 'pageTitles.home' } });
</script>

<template>
  <main :class="{ 'driver': $route.meta.driver }">
    <AppHeader />
    <div class="app-body">
      <div class="hero" v-if="$route.name === Routes.Home.Root">
        <div class="cool">
          <span data-text="Airside">Airside</span>
          <span data-text="Regulations">Regulations</span>
        </div>
      </div>
      <RouterView />
    </div>
    <AppFooter />
  </main>

  <ConfirmDialog />
  <ToastNotification />
</template>

<style scoped lang="scss">
main {
  display: grid;
  grid-template-rows: auto 1fr;
  min-height: 100vh;
}

.app-body {
  min-height: 100%;
}
</style>